import { Err } from "../../../error";
import { IPlainError } from "../../../error/toPlainError";

export const ROUTER_DATA_RECEIVED = "ROUTER_DATA_RECIEVED";
export const ROUTER_ERROR_RECEIVED = "ROUTER_ERROR_RECEIVED";

export const receiveData = (data: IRouteData) => ({
  type: ROUTER_DATA_RECEIVED,
  payload: data,
});

export const receiveError = (data: IPlainError) => ({
  type: ROUTER_ERROR_RECEIVED,
  payload: data,
});

export interface IRouteData {
  customerId: string;
  siteId: string;
  scanDate?: string;
  returnUrl?: string;
  from?: string;
  viewMode: string;
}

export interface IRouterState {
  data: IRouteData;
  error: Err;
}

const defaultState: IRouterState = {
  data: {
    customerId: null,
    scanDate: null,
    siteId: null,
    returnUrl: null,
    from: null,
    viewMode: null,
  },
  error: null,
};

export default function reducer(
  state: IRouterState = defaultState,
  action: IAction<any>,
): IRouterState {
  switch (action.type) {
    case ROUTER_DATA_RECEIVED:
      return {
        data: action.payload,
        error: null,
      };
    case ROUTER_ERROR_RECEIVED:
      return {
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
}

// every valid route should have these parameters
export const getViewMode = (routerState: IRouterState) =>
  routerState.data ? routerState.data.viewMode : null;
